var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_4564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.37225 24 0 18.6278 0 12C0 5.37225 5.37225 0 12 0C18.6278 0 24 5.37225 24 12C24 18.6278 18.6278 24 12 24ZM17.9955 12.1642L12.3735 3L6.75 12.165L12.3735 15.4298L17.9955 12.1642ZM18 13.212L12.3735 16.4753L6.75 13.2128L12.3735 20.9963L18 13.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.373 3V9.6525L17.9958 12.165L12.373 3Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.3735 3L6.75 12.165L12.3735 9.6525V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.373 16.4749V20.9952L17.9995 13.2109L12.373 16.4749Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.796,
    d: "M12.3735 20.9952V16.4742L6.75 13.2109L12.3735 20.9952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.1633L12.3735 15.4281V9.65234L6.75 12.1633Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_4564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.d691e5173ab75e2ba54b079b1dd1d0b8.svg";
export { ForwardRef as ReactComponent };